module.exports = __webpack_public_path__ + "media/images/img_voice_03-775658ec04acb8d97e846d6dc2966b15.png";